// 用户中心-会员操作
const UserMemberRouterMap = [
  // 用户会员信息页面
  {
    path: '/user/user-vip',
    component: UserVip => (require(['@/views/user/userVip'], UserVip))
  },
  // 加入会员编辑页面
  {
    path: '/user/govip',
    component: UserGoVip => (require(['@/views/user/userGoVip'], UserGoVip))
  }
]

export default UserMemberRouterMap



// WEBPACK FOOTER //
// ./src/router/modules/user/member.js